import { Store } from 'interfaces';
import { TravelCategory, TravelReason } from 'interfaces/common';

export function travelReasonSuccess(
  { reasons, categories }: { reasons: TravelReason[]; categories: TravelCategory[] },
  state: Store.State
) {
  state.travelReasons = {
    status: 'success',
    reasons,
    categories
  };
}

export function travelReasonPending(state: Store.State) {
  state.travelReasons = {
    status: 'pending'
  };
}

export function travelReasonError(error: string, state: Store.State) {
  state.travelReasons = {
    status: 'error',
    message: error
  };
}
